<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      width="500"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text class="pt-2 pb-4">
          <span v-if="!!uploading">Subiendo archivos...</span>
          <span v-else>Cargando...</span>
          <v-progress-linear
            v-model="uploading"
            :indeterminate="!uploading"
            color="white"
            background-color="grey"
            class="mb-0"
          ></v-progress-linear>
          <div class="text-right" v-if="!!uploading">
            {{ (uploading).toFixed(1) }}%
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  watch:{
    dialog(val) {
      if (!val) this.$store.commit('uploading', 0)
    }
  },
  computed: {
    dialog () {
      return this.$store.state.loading
    },
    uploading () {
      return this.$store.state.uploading * 100
    }
  }
}
</script>
